export default __webpack_public_path__ + "static/media/element_50.fe20967e.webp";